import React from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import { useBody3Variant } from '€theme/theme';
import DetailsReminder from '../UserSettings/DetailsReminder';
import { Hidden } from '€components/Hidden';

interface UserDetailsTableProps {
    title: {
        xs: string;
        sm: string;
    };
    subTitle: string;
    description: string;
    rows: {
        label: string;
        value: string;
    }[];
}

const UserDetailsTable: React.FunctionComponent<UserDetailsTableProps> = ({
    title,
    subTitle,
    rows,
    description,
}) => {
    const body3Classes = useBody3Variant();
    return (
        <Box display="flex" width="100%" flexDirection="column" mb={3}>
            <Box display="flex" flexDirection="column" mb={2}>
                <Box mb={1}>
                    <Hidden xsDown>
                        <Typography variant="subtitle1" color="textPrimary">
                            {title.xs}
                        </Typography>
                    </Hidden>
                    <Hidden smUp>
                        <Box mt={4}>
                            <Typography variant="h3" color="textPrimary">
                                {title.sm}
                            </Typography>
                        </Box>
                    </Hidden>
                </Box>
                <Hidden xsDown>
                    <Box mt={{ xs: 2, sm: 0 }}>
                        <DetailsReminder subTitle={subTitle} description={description} />
                    </Box>
                </Hidden>
            </Box>
            {rows.map(
                ({ label, value }, k) =>
                    value && (
                        <React.Fragment key={k}>
                            <Box my={2}>
                                <Typography
                                    variant="overline"
                                    classes={body3Classes}
                                    style={{ textTransform: 'uppercase', color: '#64708F' }}
                                >
                                    {label}
                                </Typography>
                                <Box>
                                    <Typography variant="subtitle1" color="textPrimary">
                                        {value}
                                    </Typography>
                                </Box>
                            </Box>
                            {k !== rows.length - 1 && <Divider />}
                        </React.Fragment>
                    ),
            )}
        </Box>
    );
};

export default UserDetailsTable;
